"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;
exports.fetchPageBySlug = fetchPageBySlug;
exports.fetchPagesByTerm = fetchPagesByTerm;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _constants = require("composer-lib/lib/constants");

var BASE_URI = 'content/api/v4';

var getQuery = function getQuery(compositionType) {
  return {
    category: compositionType === _constants.CompositionTypes.KNOWLEDGE_ARTICLE ? ['KNOWLEDGE_ARTICLE'] : ['LANDING_PAGE', 'SITE_PAGE', 'BLOG_POST', 'KNOWLEDGE_ARTICLE'],
    // enum https://git.hubteam.com/HubSpot/content4j/blob/master/ContentModel/src/main/java/com/hubspot/content/model/Category.java
    property: ['id', 'name', 'absoluteUrl'],
    // fields of https://git.hubteam.com/HubSpot/content4j/blob/master/ContentModel/src/main/java/com/hubspot/content/model/Content.java
    limit: 1000
  };
};

function fetch(compositionType) {
  return _apiClient.default.get(BASE_URI + "/contents/published", {
    query: getQuery(compositionType)
  });
}

function fetchPageBySlug(slug) {
  return _apiClient.default.get(BASE_URI + "/contents", {
    query: {
      slug: slug
    }
  });
}

function fetchPagesByTerm(term, offset) {
  return _apiClient.default.get('contentsearch/v2/search/internal', {
    query: {
      term: term,
      offset: offset
    }
  });
}